
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.788 23c-.286 0-.56-.116-.763-.32l-2.708-2.727a1.105 1.105 0 010-1.55L5.4 15.201a3.582 3.582 0 012.508-1.015c.11 0 .218 0 .32.014h5.16c.412.002.81.152 1.121.425.312.272.516.649.575 1.06a1.64 1.64 0 01-.324 1.196c-.26.34-.643.562-1.064.619h-4.61a.543.543 0 00-.385.161.552.552 0 00.386.939h4.361a2.704 2.704 0 001.896-.768c.51-.495.807-1.17.83-1.883l3.63-3.63a1.09 1.09 0 01.774-.325 1.083 1.083 0 01.773.325H21.3a1.101 1.101 0 01.239 1.204 1.101 1.101 0 01-.239.358l-6.06 6.116a2.724 2.724 0 01-1.928.803H8.869c-.287 0-.561.115-.764.319l-1.548 1.562a1.084 1.084 0 01-.769.319zm10.11-8.34a2.727 2.727 0 00-.814-1.01V9.8c0-.292.115-.572.32-.778a1.086 1.086 0 011.541 0c.205.206.32.486.32.778v3.487l-1.362 1.374h-.006zM8.541 9.8a4.335 4.335 0 01-2.424-.742 4.392 4.392 0 01-1.606-1.974 4.436 4.436 0 01-.248-2.542 4.412 4.412 0 011.193-2.253 4.35 4.35 0 012.234-1.204 4.326 4.326 0 012.52.25 4.37 4.37 0 011.957 1.62 4.428 4.428 0 01-.542 5.556A4.342 4.342 0 018.542 9.8zm0-6.6c-.432 0-.853.129-1.212.37a2.196 2.196 0 00-.803.988A2.218 2.218 0 007 6.956a2.163 2.163 0 002.377.477c.398-.167.738-.449.978-.81a2.214 2.214 0 00-.271-2.779A2.171 2.171 0 008.542 3.2z","fill":"#fff"}})])
          )
        }
      }
    